import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { Store } from '@ngrx/store';
import { catchError, throwError } from 'rxjs';
import * as UserActions from '@store/user/user.actions';
import { AuthService, ConsoleRoute } from '@klubovna/shared-data';
import { ApiErrorCode } from '@klubovna/shared-models';

const isPasswordChangeRequired = (error: HttpErrorResponse): boolean =>
  error.status === HttpStatusCode.Forbidden && error.error?.code === ApiErrorCode.PasswordChangeRequired;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const store = inject(Store);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  if (req.url.includes('/auth/login') || req.url.includes('/auth/register')) {
    return next(req);
  }

  const token = authService.getToken();

  if (token) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${ token }`),
    });
    return next(authReq).pipe(
      catchError((error) => {
        if (error.status === 401) {
          authService.clearAuthData();
          store.dispatch(UserActions.forceLogout());
          const currentUrl = router.url;
          const isProtectedRoute = currentUrl.startsWith('/admin') || currentUrl.startsWith('/volunteer') || currentUrl.startsWith('/pos');
          if (isProtectedRoute) {
            router.navigate([ '/login' ], { queryParams: { returnUrl: currentUrl } });
          }
        }
        if (isPasswordChangeRequired(error) && !router.url.startsWith(ConsoleRoute.ChangePassword)) {
          router.navigate([ ConsoleRoute.ChangePassword ]);
        }
        return throwError(() => error);
      }),
    );
  }

  return next(req);
};
